import React from 'react';
import { twMerge } from 'tailwind-merge';

import CallBadge from './CallBadge';
import ElapsedTime from './ElapsedTime';

interface Props {
    badge: React.ReactNode;
    since?: string | number;
    // An icon or a bare number says nothing on its own, so these name the two
    // halves for screen readers, which read each name ahead of its value.
    label?: string;
    timeLabel?: string;
}

const CallBadgeWithTime = ({ badge, since, label, timeLabel }: Props) => (
    <div
        className={twMerge(
            'flex items-center justify-start rounded-sm bg-gray-200',
            // Room for the elapsed time is only reserved when there is one to
            // show, so a badge on its own trails no empty backplate.
            since && 'min-w-16',
        )}
    >
        {label ? <span className="sr-only">{label}</span> : null}
        <CallBadge>{badge}</CallBadge>
        {since ? (
            <div className="flex px-1 text-xs tracking-wide">
                {timeLabel ? (
                    <span className="sr-only">{timeLabel}</span>
                ) : null}
                <ElapsedTime since={since} />
            </div>
        ) : null}
    </div>
);

export default CallBadgeWithTime;
